'use strict';

document.addEventListener("turbo:load", () => {
  const burger = document.getElementById('hamburger');
  burger.addEventListener('click', () => {
    document.querySelector('.navigation').classList.toggle('active');
    burger.classList.toggle('is-active');
  });
});
